import { siteMeta } from "../data/siteMeta";
import { trackEvent } from "../lib/telemetry";

export default function GoodreadsLink({ children = "Goodreads", className = "text-link", destination = "author", source = "site" }) {
  const targetUrl = destination === "book" ? siteMeta.bookOneGoodreadsUrl : siteMeta.goodreadsAuthorUrl;

  function handleClick() {
    trackEvent("Social Link Clicked", {
      platform: "Goodreads",
      source,
      target_url: targetUrl,
    });
  }

  return (
    <a
      className={className}
      href={targetUrl}
      target="_blank"
      rel={`${destination === "author" ? "me " : ""}noopener noreferrer`}
      onClick={handleClick}
    >
      {children}
      <span aria-hidden="true">↗</span>
    </a>
  );
}
